import { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import { useNavigate } from 'react-router-dom';
import { useEmpresa } from '../../contexts/EmpresaContext';

export default function HomePage() {
  const navigate = useNavigate();
  const { empresaSelecionada } = useEmpresa();
  const [dadosEmpresa, setDadosEmpresa] = useState({
    saldoTotal: 'R$ 2.450,00',
    campanhasAtivas: '12',
    pontosDisponiveis: '1.250',
    notificacoes: '3',
    crescimento: '+25%',
    engajamento: '89%',
    metasAtingidas: '12 de 15'
  });

  // Recarregar dados quando a empresa mudar
  useEffect(() => {
    carregarDadosEmpresa();
  }, [empresaSelecionada.id]);

  const carregarDadosEmpresa = () => {
    console.log('Carregando dados da home para empresa:', empresaSelecionada.id, empresaSelecionada.nome);
    
    // Simular dados diferentes por empresa
    const dadosPorEmpresa = {
      1: { // TechCorp Soluções Ltda
        saldoTotal: 'R$ 2.450,00',
        campanhasAtivas: '12',
        pontosDisponiveis: '1.250',
        notificacoes: '3',
        crescimento: '+25%',
        engajamento: '89%',
        metasAtingidas: '12 de 15'
      },
      2: { // Inovação Digital S.A.
        saldoTotal: 'R$ 1.890,00',
        campanhasAtivas: '8',
        pontosDisponiveis: '890',
        notificacoes: '5',
        crescimento: '+18%',
        engajamento: '76%',
        metasAtingidas: '8 de 12'
      },
      3: { // Consultoria Tech Brasil
        saldoTotal: 'R$ 3.120,00',
        campanhasAtivas: '15',
        pontosDisponiveis: '2.100',
        notificacoes: '2',
        crescimento: '+32%',
        engajamento: '94%',
        metasAtingidas: '14 de 16'
      },
      4: { // Sistemas Integrados Ltda
        saldoTotal: 'R$ 1.650,00',
        campanhasAtivas: '6',
        pontosDisponiveis: '750',
        notificacoes: '7',
        crescimento: '+15%',
        engajamento: '82%',
        metasAtingidas: '5 de 8'
      }
    };

    const novosDados = dadosPorEmpresa[empresaSelecionada.id as keyof typeof dadosPorEmpresa] || dadosPorEmpresa[1];
    setDadosEmpresa(novosDados);
  };

  const quickStats = [
    { title: 'Saldo Total', value: dadosEmpresa.saldoTotal, icon: 'ri-wallet-3-line', color: 'emerald' },
    { title: 'Campanhas Ativas', value: dadosEmpresa.campanhasAtivas, icon: 'ri-megaphone-line', color: 'blue' },
    { title: 'Pontos Disponíveis', value: dadosEmpresa.pontosDisponiveis, icon: 'ri-coin-line', color: 'orange' },
    { title: 'Notificações', value: dadosEmpresa.notificacoes, icon: 'ri-notification-3-line', color: 'slate' }
  ];

  const recentActivities = [
    { action: 'Pontos creditados', description: `Campanha "Vendas Q4" - 150 pontos para ${empresaSelecionada.nome}`, time: '2 min atrás', icon: 'ri-coin-line' },
    { action: 'Nova campanha', description: `Campanha "Meta Dezembro" foi criada em ${empresaSelecionada.nome}`, time: '1 hora atrás', icon: 'ri-megaphone-line' },
    { action: 'Prêmio resgatado', description: 'Vale-presente de R$ 100 resgatado', time: '3 horas atrás', icon: 'ri-gift-line' },
    { action: 'Participante adicionado', description: `João Silva foi adicionado à campanha em ${empresaSelecionada.nome}`, time: '5 horas atrás', icon: 'ri-user-add-line' }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      emerald: 'bg-emerald-500',
      blue: 'bg-blue-600',
      orange: 'bg-orange-500',
      slate: 'bg-slate-600'
    };
    return colors[color as keyof typeof colors];
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Welcome Header */}
        <div className="bg-gradient-to-r from-blue-600 to-orange-500 rounded-lg p-6 text-white">
          <h1 className="text-2xl font-bold mb-2">Bem-vindo à Plataforma iBanX</h1>
          <p className="text-blue-100">Empresa ativa: {empresaSelecionada.nome} - CNPJ: {empresaSelecionada.cnpj}</p>
        </div>

        {/* Quick Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickStats.map((stat, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900 mt-2">{stat.value}</p>
                </div>
                <div className={`w-12 h-12 rounded-lg ${getColorClasses(stat.color)} flex items-center justify-center`}>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${stat.icon} text-white text-xl`}></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Visão Geral de Performance */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">Visão Geral de Performance - {empresaSelecionada.nome}</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-line-chart-line text-blue-600 text-2xl"></i>
                </div>
              </div>
              <h4 className="font-semibold text-gray-900">Crescimento</h4>
              <p className="text-sm text-gray-600 mt-1">{dadosEmpresa.crescimento} este mês</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-user-heart-line text-orange-600 text-2xl"></i>
                </div>
              </div>
              <h4 className="font-semibold text-gray-900">Engajamento</h4>
              <p className="text-sm text-gray-600 mt-1">{dadosEmpresa.engajamento} de participação</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-trophy-line text-emerald-600 text-2xl"></i>
                </div>
              </div>
              <h4 className="font-semibold text-gray-900">Metas Atingidas</h4>
              <p className="text-sm text-gray-600 mt-1">{dadosEmpresa.metasAtingidas} campanhas</p>
            </div>
          </div>
        </div>

        {/* Informações do Sistema */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-white/70 backdrop-blur-sm rounded-lg p-4 border border-gray-200 shadow-sm">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-white"></i>
                </div>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Tempo Médio</h4>
                <p className="text-sm text-gray-600">2-3 dias úteis para ciclo completo</p>
              </div>
            </div>
          </div>

          <div className="bg-white/70 backdrop-blur-sm rounded-lg p-4 border border-gray-200 shadow-sm">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-emerald-500 rounded-lg flex items-center justify-center">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shield-check-line text-white"></i>
                </div>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Segurança</h4>
                <p className="text-sm text-gray-600">Todas as transações são auditadas</p>
              </div>
            </div>
          </div>

          <div className="bg-white/70 backdrop-blur-sm rounded-lg p-4 border border-gray-200 shadow-sm">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-line text-white"></i>
                </div>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Suporte</h4>
                <p className="text-sm text-gray-600">Acompanhamento 24/7 disponível</p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Ações Rápidas */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-6">Ações Rápidas</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { title: 'Conta Digital', description: 'Gerencie sua conta digital', icon: 'ri-bank-card-line', path: '/admin/conta-digital', color: 'blue' },
                { title: 'Cartão Pré-Pago', description: 'Controle seu cartão pré-pago', icon: 'ri-bank-card-2-line', path: '/admin/cartao-prepago', color: 'emerald' },
                { title: 'Campanhas', description: 'Crie e gerencie campanhas', icon: 'ri-megaphone-line', path: '/admin/incentivo/campanhas', color: 'orange' },
                { title: 'Relatórios', description: 'Visualize relatórios detalhados', icon: 'ri-file-chart-line', path: '/admin/incentivo/relatorios', color: 'slate' }
              ].map((action, index) => (
                <button
                  key={index}
                  onClick={() => navigate(action.path)}
                  className="flex items-center space-x-3 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap text-left"
                >
                  <div className={`w-10 h-10 rounded-lg ${getColorClasses(action.color)} flex items-center justify-center`}>
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${action.icon} text-white`}></i>
                    </div>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{action.title}</p>
                    <p className="text-sm text-gray-600">{action.description}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Recent Activities */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Atividades Recentes</h3>
              <button className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer whitespace-nowrap">
                Ver todas
              </button>
            </div>
            <div className="space-y-4">
              {recentActivities.map((activity, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${activity.icon} text-gray-600`}></i>
                    </div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-gray-900">{activity.action}</p>
                    <p className="text-sm text-gray-600">{activity.description}</p>
                    <p className="text-xs text-gray-500 mt-1">{activity.time}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
